import React from 'react';

interface Props {
  className?: string;
  fill?: string;
}
export default function CheckCircleIcon({ className, fill }: Props) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM7.45446 13.2289C7.25885 13.4245 7.25926 13.7418 7.45538 13.9369L9.97978 16.4483C10.1752 16.6427 10.4911 16.6423 10.686 16.4474L16.5464 10.5869C16.7417 10.3916 16.7417 10.075 16.5464 9.87978L15.7869 9.12021C15.5916 8.92495 15.275 8.92495 15.0798 9.12022L10.3333 13.8667L8.93687 12.4569C8.74189 12.2601 8.42401 12.2593 8.2281 12.4552L7.45446 13.2289Z"
        fill={fill || 'currentColor'}
      />
    </svg>
  );
}
